import './profile-cell.scss';
import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../../../store';
import { ProfilesOfRule, SecurityType, securityTypeMapping } from '../../../../dtos/version.dto';
import CustomIcon, { IconType } from '../../../shared/custom-icon/custom-icon';

interface ProfileCellProps {
    profiles: ProfilesOfRule;
}

export const ProfileCell: React.FC<ProfileCellProps> = observer(({profiles}) => {
    const {fwVersionStore} = useStores();

    const urlFilteringProfileName = useMemo(() => {
        const versionProfiles = fwVersionStore.selectedFwVersion?.content.policy.url_filtering;
        return versionProfiles?.find(p => p.id === profiles.url_filtering)?.displayName || '';
    }, [fwVersionStore.selectedFwVersion, profiles]);

    const securityTypes = Object.values(SecurityType);

    const extractActionFromSecurityProfileValue = (securityProfile: string, securityType: SecurityType) => { // to changes
        if (securityType === SecurityType.DNS || securityType === SecurityType.AntiSpyware) {
            const matchProfile = fwVersionStore.selectedFwVersion?.content.policy.profiles?.find(p => p.id === securityProfile);
            if (!matchProfile) return null;
            return matchProfile[securityType === SecurityType.DNS ? 'dns' : 'antispyware'];
        }

        const securityProfileValues = securityProfile.split('_');
        return securityProfileValues.at(-1);
    };

    return <div className={'table-cell-elements-container'}>
        {profiles.url_filtering && <div className={'table-cell-single-element'}>{urlFilteringProfileName}</div>}
        {securityTypes.map(securityType => {
            const profileFullValue = profiles[securityType === SecurityType.DNS ? SecurityType.AntiSpyware : securityType];
            if (!profileFullValue) return null;

            const value = extractActionFromSecurityProfileValue(profileFullValue, securityType);
            return <div className="security-profile" key={securityType}>
                <div className={`security-action ${value}`}>
                    <CustomIcon className={`security-action ${value}`}
                        type={value === 'block' ? IconType.BLOCK_ICON : IconType.ADVANCE_PROTECTION_ALERT} />
                </div>
                <div>{securityTypeMapping[securityType]}</div>
            </div>;
        })}
    </div>;
});